// IMR Theme JavaScript
(function() {
  'use strict';
  
  // Initialize theme functionality when DOM is ready
  document.addEventListener('DOMContentLoaded', function() {
    initializeTheme();
  });

  // Re-initialize on section load events from Shopify theme editor
  document.addEventListener('shopify:section:load', function(event) {
    initializeTheme(event.detail.sectionId);
  });

  /**
   * Main theme initialization function
   * @param {string} sectionId - Optional section ID if being called from section:load event
   */
  function initializeTheme(sectionId) {
    // Initialize mobile menu
    initMobileMenu();
    
    // Initialize sticky header if enabled in theme settings
    initStickyHeader();
    
    // Setup any lazyloading for images
    initLazyLoading();
  }

  /**
   * Initialize the mobile menu functionality
   */
  function initMobileMenu() {
    const mobileMenuToggle = document.querySelector('.mobile-menu-toggle');
    if (!mobileMenuToggle) return;
    
    const mobileMenu = document.querySelector('.mobile-menu');
    if (!mobileMenu) return;
    
    mobileMenuToggle.addEventListener('click', function(e) {
      e.preventDefault();
      document.body.classList.toggle('mobile-menu-open');
      mobileMenuToggle.classList.toggle('active');
      mobileMenu.classList.toggle('active');
    });
  }

  /**
   * Initialize sticky header behavior
   */
  function initStickyHeader() {
    const header = document.querySelector('.header--sticky');
    if (!header) return;
    
    let lastScrollTop = 0;
    
    window.addEventListener('scroll', function() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      
      if (scrollTop > 50) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
      
      lastScrollTop = scrollTop;
    }, { passive: true });
  }

  /**
   * Setup lazy loading for images
   */
  function initLazyLoading() {
    // Check if native lazy loading is supported
    if ('loading' in HTMLImageElement.prototype) {
      const lazyImages = document.querySelectorAll('img[loading="lazy"]');
      lazyImages.forEach(img => {
        if (img.dataset.src) {
          img.src = img.dataset.src;
          delete img.dataset.src;
        }
      });
    } else {
      // Fallback lazy loading implementation if needed
      const lazyImages = document.querySelectorAll('img[data-src]');
      
      if (lazyImages.length === 0) return;
      
      const lazyImageObserver = new IntersectionObserver(function(entries, observer) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            const lazyImage = entry.target;
            lazyImage.src = lazyImage.dataset.src;
            lazyImage.removeAttribute('data-src');
            lazyImageObserver.unobserve(lazyImage);
          }
        });
      });

      lazyImages.forEach(function(lazyImage) {
        lazyImageObserver.observe(lazyImage);
      });
    }
  }
})();
